import React, {Component} from "react";
import applogic from "../applogic.js";

class ModalToken extends Component {
    render() {
        return (
            <div className="modal fade" id="modalToken" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Login using IVLE Web API</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="token">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="panel panel-default">
                                            <div className="list-group">
                                                <div className="list-group-item">
                                                    <h4 className="list-group-heading">Disclaimer</h4>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">First thing first, we are not keeping your password</p>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">Although we strongly encourage you to login directly using the login form provided, we understand some of you are security concerned, such that you do not wish to input IVLE credentials on a third party website.</p>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">Therefore we provide the following alternative, which is more troublesome. We avoid using it as our main login option due to the damage to user experience.</p>
                                                </div>
                                                <div className="list-group-item">
                                                    <h4 className="list-group-heading">Step 1</h4>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">Make sure you have logged into IVLE portal and then switch back to this page!</p>
                                                    <p className="list-group-text">Click here: <a href="https://ivle.nus.edu.sg/" target="_blank">https://ivle.nus.edu.sg</a></p>
                                                </div>
                                                <div className="list-group-item">
                                                    <h4 className="list-group-heading">Step 2</h4>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">Now login again by clicking the following link :-(</p>
                                                    <div className="clear"/>
                                                    <p className="list-group-text">Click here: <a href={"https://ivle.nus.edu.sg/api/login/?apikey=AaqXNkxgYT3xYQR8qQG6Z&url=" + applogic.removeQueryParam('token')}>Link to IVLE API Login Form</a></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalToken;


// WEBPACK FOOTER //
// ./src/componentsHeader/ModalToken.js